module.exports = __webpack_public_path__ + "img/lg_ring_0_0_null_null@3x.8ed0fcca.png";